import NavFilterTile from "components/core/blocks/NavFilterTile";
import { setChannel } from "redux/reducers/channel";
import { getAccountsOptions } from "../../../modules/admin/api/useAccounts";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useQuery } from "@tanstack/react-query";
import type { AccountsResponse } from "../../../zodios/apiDefinitions/api/accounts";

const hasProfiles = (data: AccountsResponse) => {
  return Object.keys(data.seller).length > 0 || Object.keys(data.vendor).length > 0;
};

function SellerChannels({ mobileSidebarItem }: { mobileSidebarItem?: boolean }) {
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const dispatch = useAppDispatch();
  const walmartChannelQuery = useQuery(getAccountsOptions("walmart"));
  const shopifyChannelQuery = useQuery(getAccountsOptions("shopify"));

  return (
    <NavFilterTile
      selectedKey={channel}
      onSelectionChange={(id) => {
        dispatch(setChannel(id));
        localStorage.setItem("channel", id);
        window.location.reload();
      }}
      items={[
        {
          value: "amazon",
          label: "Amazon",
        },
        {
          value: "walmart",
          label: "Walmart",
          isDisabled: !walmartChannelQuery.data || !hasProfiles(walmartChannelQuery.data),
        },
        {
          value: "shopify",
          label: "Shopify",
          isDisabled: !shopifyChannelQuery.data || !hasProfiles(shopifyChannelQuery.data),
        },
      ]}
      mobileSidebarItem={mobileSidebarItem}
    />
  );
}

export default SellerChannels;
